// frontend/src/components/ForgotPassword.tsx
import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

import { buildApiUrl } from '../config/api';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await axios.post(buildApiUrl('users/auth/reset-password/'), {
        email
      });
      
      setSuccess(response.data.message);
    } catch (err: any) {
      setError(err.response?.data?.error || 'שגיאה בשליחת בקשת איפוס סיסמה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: '600px', direction: 'rtl' }}>
      <Card>
        <Card.Header as="h3" className="text-center">
          שכחתי סיסמה
        </Card.Header>
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && (
            <Alert variant="success">
              {success}
            </Alert>
          )}
          
          {!success && (
            <>
              <Alert variant="info">
                הזן את כתובת האימייל שלך ונשלח אליך קישור לאיפוס הסיסמה.
              </Alert>
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>אימייל</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                    placeholder="your@email.com"
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 mb-3"
                  disabled={loading}
                >
                  {loading ? 'שולח...' : 'שלח קישור לאיפוס'}
                </Button>
              </Form>
            </>
          )}

          <hr />

          <div className="text-center">
            <Link to="/login" className="text-muted">
              חזרה להתחברות
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ForgotPassword;
